import template from './sw-cms-el-preview-acris-blog-content.html.twig';
import './sw-cms-el-preview-acris-blog-content.scss';

const { Component } = Shopware;

Component.register('sw-cms-el-preview-acris-blog-content', {
    template
});